import {
  type ColorInterpolatorFactory,
  InterpolationMethod,
} from "../color-interpolator";
import type { HasBackgroundColor, PixelAccessor } from "../pixel-accessor";
import type {
  ColorResamplerFactory,
  ColorResamplerFactoryOptions,
} from "./ColorResamplerFactory";
import { PointResampler } from "./PointResampler";
import type { ReversePixelMapper } from "../pixel-mapper";

/**
 * PointResampler factory class.
 */
export class PointResamplerFactory implements ColorResamplerFactory {
  /**
   * PointResamplerFactory constructor.
   * @param colorInterpolatorFactory
   */
  constructor(
    private readonly colorInterpolatorFactory: ColorInterpolatorFactory
  ) {}

  /**
   * @inheritDoc
   */
  readonly supportsEwa = false;

  /**
   * @inheritDoc
   */
  readonly requiresResampleFilter = false;

  /**
   * @inheritDoc
   */
  create(
    image: PixelAccessor & HasBackgroundColor,
    reversePixelMapper: ReversePixelMapper,
    options: ColorResamplerFactoryOptions = {}
  ): PointResampler {
    const {
      matteColor = [0, 0, 0, 0],
      interpolationMethod = InterpolationMethod.AVERAGE,
    } = options;

    return new PointResampler(
      image,
      reversePixelMapper,
      this.colorInterpolatorFactory.create(interpolationMethod),
      matteColor
    );
  }
}
